import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrCH: CultureInfo = {
  name: 'fr-CH',
  displayName: 'French (Switzerland)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-CH',
  parent: CultureInfoFr
};
